export const b2bLanguageCodes = ['de', 'fr', 'it'];
export const languageCodes = ['de', 'fr', 'it', 'en'];
const { getLocale } = { getLocale: () => "fr" };
export function getLanguageCode() {
    if (['localhost', 'bs-local.com'].includes(document.location.hostname) &&
        document.location.port !== '8000') {
        const pathSplited = location.pathname
            .split('/')
            .filter((part) => part !== '');
        const lang = pathSplited[0];
        if (!languageCodes.includes(lang))
            return 'en';
        return lang;
    }
    const code = getLocale();
    return code === 'de-ch' ? 'de' : code;
}
//# sourceMappingURL=i18n.js.map